import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { TldOfferWidgetLayout } from '../tldOfferWidget.layout';
export const bmLayout = {
  ...TldOfferWidgetLayout,
  StripContainer: props => /*#__PURE__*/React.createElement(TldOfferWidgetLayout.StripContainer, _extends({
    backgroundColor: "white"
  }, props)),
  CarouselStripContainer: props => /*#__PURE__*/React.createElement(TldOfferWidgetLayout.CarouselStripContainer, _extends({
    backgroundColor: "white"
  }, props)),
  CardContainer: props => /*#__PURE__*/React.createElement(TldOfferWidgetLayout.CardContainer, _extends({
    border: "1px solid var(--wds-color-black-550)"
  }, props))
};
//# sourceMappingURL=bm.layout.js.map